module.exports = __webpack_public_path__ + "3e1ca86b24ee392509051cb5d8d4252a.MP3";